import { useState } from "react";
import { useQuery } from "react-query";
import type { ApiError } from "@circle-react/config/CustomErrors";
import { internalApi } from "@circle-react/helpers/urlHelpers";

interface AccountPaymentProcessorInvoiceType {
  hosted_invoice_url: string;
}

export const useLatestInvoice = () => {
  const [shouldRetrieveInvoice, setShouldRetrieveInvoice] = useState(false);

  const onRetrieveLatestInvoice = () => {
    setShouldRetrieveInvoice(prev => !prev);
  };

  const { data: latestInvoice, isLoading: isLoadingInvoice } = useQuery<
    AccountPaymentProcessorInvoiceType,
    ApiError
  >(internalApi.accountPaymentProcessors.invoice.show(), {
    enabled: shouldRetrieveInvoice,
  });

  return {
    latestInvoice,
    isLoadingInvoice,
    onRetrieveLatestInvoice,
    shouldRetrieveInvoice,
  };
};
